import { auth, provider, db } from '../firebase';
import { signInWithPopup } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { addDoc, collection, getDocs } from 'firebase/firestore';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaGoogle } from "react-icons/fa6";
import "./App.css"


function Login({ setIsAuth, setIsAdmin }) {
  var navigate = useNavigate();
  const adminEmail = process.env.REACT_APP_Admin_Email;


  const signIn = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const name = user.displayName;
      const email = user.email;

      setIsAuth(true);
      navigate('/');
      if (adminEmail === user.email) {
        setIsAdmin(true)
        addUsers(name, true,email); 
      } else {
        addUsers(name, false,email); 
      }
     
    } catch (error) {
      console.error(error);
    }
  };
 

  const addUsers = async (name, admin, email) => {
    try {
      const querySnapshot = await getDocs(collection(db, "users"));
      const existingUser = querySnapshot.docs.find(doc => doc.data().uid === auth.currentUser.uid);
    
      if (!existingUser) {
        await addDoc(collection(db, 'users'), {
          name: name,
          isAdmin: admin,
          email: email,
          uid: auth.currentUser.uid 
        });
      }
    } catch (error) {
      console.error("Error adding user to Firestore: ", error);
    }
  };
  
  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <div className="login-container">
            <h3>Login</h3>
            <Form>
              <Button variant="primary" onClick={signIn} className="w-100">
                Sign in with Google     
                
               <FaGoogle style={{marginLeft: '4px'}}/>
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
